// Common Constants

export class Everest {
  static readonly DMS_IDEAL_STR: string = 'Ideal';
  static readonly DMS_CSYSTEMS_STR: string = 'c-Systems';
  static readonly DMS_CHARTER_STR: string = 'Charter';

  static readonly EmptyGuid = '00000000-0000-0000-0000-000000000000';

  static readonly EVEREST_API_STATUS_CODE_SUCCESS = 'Successful';
  static readonly EVEREST_API_STATUS_CODE_GENERAL_ERROR = 'GeneralError';
  static readonly EVEREST_API_STATUS_CODE_DUPLICATE_ERROR = 'DuplicateError';
}

export class DataGridSettings {
  // DataGrid constants ----------------------------------------------------------
  static readonly Data_Grid_Row_Height: number = 35; // 28;
  static readonly Data_Grid_Header_Height: number = 50;
  static readonly Data_Grid_Header_Double_Height: number = 50;
  static readonly Data_Grid_Page_Size: number = 100;
}
